import { createSlice } from "@reduxjs/toolkit";

import {
  AREA_COLORS,
  MapModes,
  MapToolsModes,
  OperationModes,
  LayerAlias,
  UnitTrainingClassificationTypes
} from "constant";
export interface MapAriesInterface {
  radius: number;
  name: string;
  color: string;
  isActive: boolean;
  alias: string;
}

interface GeoDataInterface {
  type: string;
  coordinates: number[];
}

export interface MarkerInterface {
  layerAlias: LayerAlias;
  color: string;
  created_at: string;
  geo_data: GeoDataInterface;
  id: string;
  name: string;
  additional: {
    classification: any;
    probability: number;
    object_type?: string;
  };
}

export interface PolygonInterface {
  coordinates: number[];
  id: string;
  alias: string;
  color: string;
  text: string;
  isActive?: boolean;
}

export interface MapStateInterface {
  isProjectLoading: boolean;
  isPolygonsLoading: boolean;
  isMarkersLoading: boolean;
  isMarkerDetailsLoading: boolean;
  isLayerCreateLoading: boolean;
  isMarkerCreateLoading: boolean;
  isMarkerDeleteLoading: boolean;
  markersTrainingClassifyLoading: any[];
  title: string;
  id: string;
  // markers: MarkerInterface[];
  aries: MapAriesInterface[];
  polygons: MarkerInterface[];
  markerDetails: MarkerDetailsInterface;
  mapToolsMode: MapToolsModes;
  operationMode: OperationModes;
  mapMode: MapModes;
}

export interface MarkerDetailsInterface {
  alias: LayerAlias;
  additional?: {
    mine_id?: number;
    probability?: number;
    classification?: any;
    training_classification?: UnitTrainingClassificationTypes;
    object_diameter?: number;
  };
  name: string;
  id: string;
  images: string[];
  geo_data: {
    type: string;
    coordinates: number[];
  };
  isActive?: boolean;
  wikiData?: any;
}

const initialState: MapStateInterface = {
  isProjectLoading: false,
  isPolygonsLoading: false,
  isMarkersLoading: false,
  isLayerCreateLoading: false,
  isMarkerDetailsLoading: false,
  isMarkerDeleteLoading: false,
  isMarkerCreateLoading: false,
  markersTrainingClassifyLoading: [],
  title: "",
  id: "",
  aries: AREA_COLORS,
  polygons: [],
  markerDetails: null,
  mapToolsMode: MapToolsModes.LAYERS,
  operationMode: OperationModes.GRASSCUTTERS,
  mapMode: MapModes.DEFAULT
};

export const mainSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    fetchProjectRequest: (state) => {
      state.isProjectLoading = true;
    },
    fetchProjectSuccess: (state, { payload }) => {
      state.isProjectLoading = false;
      state.title = payload.name;
      state.id = payload.id;
    },
    fetchProjectError: (state) => {
      state.isProjectLoading = false;
    },

    setPointDetails: (state, { payload }) => {
      state.markerDetails = {
        ...state.markerDetails,
        ...payload,
        isActive: true,
        wikiData: undefined
      };
    },

    clearPointDetails: (state) => {
      state.markerDetails = { ...state.markerDetails, isActive: false };
    },

    updatePointTrainingClassificationRequest: (state, { payload }) => {
      state.markersTrainingClassifyLoading = [
        ...state.markersTrainingClassifyLoading,
        {
          id: payload.params.unitId,
          training_classification: payload.fields.classification
        }
      ];
    },

    updatePointTrainingClassificationSuccess: (state, { payload }) => {
      state.markersTrainingClassifyLoading =
        state.markersTrainingClassifyLoading.filter(
          (project) => project.id !== payload.params.unitId
        );

      if (payload.params.unitId === state.markerDetails.id) {
        state.markerDetails = {
          ...state.markerDetails,
          ...payload.data
        };
      }
    },

    updatePointTrainingClassificationError: (state, { payload }) => {
      state.markersTrainingClassifyLoading =
        state.markersTrainingClassifyLoading.filter(
          (project) => project.projectId !== payload.params.projectId
        );
    },

    fetchPointWikiDetailsRequest: (state, _) => {
      state.isMarkerDetailsLoading = true;
    },
    fetchPointWikiDetailsSuccess: (state, { payload }) => {
      state.isMarkerDetailsLoading = false;
      state.markerDetails = { ...state.markerDetails, wikiData: payload[0] };
    },
    fetchPointWikiDetailsError: (state) => {
      state.isMarkerDetailsLoading = false;
    },

    setAriaIsActive: (state, { payload }) => {
      state.aries = state.aries.map((item) =>
        item.alias === payload.alias
          ? { ...item, isActive: payload.isActive ?? !item.isActive }
          : item
      );
    },

    setMapToolsMode: (state, { payload }) => {
      state.mapToolsMode = payload;
    },
    setOperationMode: (state, { payload }) => {
      state.operationMode = payload;
    },
    setMapMode: (state, { payload }) => {
      state.mapMode = payload;
    },

    restoreDefaultState: () => initialState
  }
});

export const { actions, reducer } = mainSlice;
